export const positiveEvQuery = {
  range: {
    expectedValue: {
      gte: 0,
    },
  },
};
